<template>
    <div class="body_img">
        <div id="home_login_div" class="login">
            <div class="input_area">
                <div class="title1">
                    用户登陆
                </div>
            </div>
            <div class="input_area">
                <input id="LOGIN_NAME" type="text" class="big_txt1" placeholder="用户名..." v-model="LOGIN_NAME"
                    autocomplete="off" />
            </div>
            <div class="input_area">
                <input id="LOGIN_PWD" type="password" class="big_txt1" placeholder="密码..." v-model="LOGIN_PWD"
                    autocomplete="off" />
            </div>
            <div class="input_area">
                <div id="left_YZM">
                    <input id="YZM" type="text" class="big_txt1" placeholder="验证码" v-model="YZM" @keyup="onKeyDownchange"
                        autocomplete="off" />
                </div>
                <div id="left_YZMA" @click="RefreshYZM">
                    <a id="YZMA" href="javaScript:void(0);">
                        <img id="YZMImg" :src="YZMImg" />
                    </a>
                </div>
            </div>
            <div class="input_area">
                <button type="button" id="btn_login" @click="toLogin">
                    <template v-if="logonNow == 0">登陆</template>
                    <template v-if="logonNow == 1">登陆中...</template>
                </button>
            </div>
            <div class="input_area">
                <a href="javaScript:void(0);" style="float:left;" @click="testUser">测试用户</a>
                <a href="#/forgetpwd" style="float: right; margin-right: 10px;">忘记密码</a>
            </div>
            <div class="input_area">
                <div id="tip_login" class="tip_default tip_error">
                    {{ errmsg }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import gConfig from '../gConfig';
let Base64 = require('js-base64').Base64;

export default {
    name: 'login',
    data() {
        return {
            logonNow: 0,
            LOGIN_NAME: '',
            LOGIN_PWD: '',
            YZM: '',
            YZMImg: gConfig.web_pc + '/home/IndexMain/GetCheckCode',
            errmsg: ''
        }
    },
    methods: {
        RefreshYZM() {
            var src1 = gConfig.web_pc + '/home/IndexMain/GetCheckCode?t=' + new Date().getMilliseconds();
            this.YZMImg = src1;
        },
        onKeyDownchange(e) {
            if (e.keyCode == 13) { // 事件操作
                this.toLogin();
            }
        },
        CheckYZM() {
            this.errmsg = '';
            if (this.YZM == undefined || this.YZM == null || this.YZM == '') {
                this.errmsg = '请输入验证码';
                return false;
            } else if (this.YZM.length != 4) {
                this.errmsg = '验证码不正确';
                return false;
            }
            return true;
        },
        testUser() {
            this.LOGIN_NAME = 'test';
            this.LOGIN_PWD = 'test,123';
            this.YZM = '1111';
        },
        toLogin() {
            if (!this.CheckYZM()) {
                return;
            }
            const self = this;
            var params = new URLSearchParams();
            params.append('LOGIN_NAME', self.LOGIN_NAME);
            params.append('LOGIN_PWD', Base64.encode(self.LOGIN_PWD));
            params.append('CHECK_CODE', self.YZM);
            self.logonNow = 1;
            axios.post(gConfig.web_pc + '/home/IndexMain/loginGo', params).then(function (response) {
                self.RefreshYZM();
                var data = response.data;
                var flag = data.flag;
                var msg = data.msg;
                if (flag) {
                    self.errmsg = '登录成功，自动跳转';
                    window.location = '/home/desktop/index.html';
                } else {
                    self.errmsg = msg;
                }
                self.logonNow = 0;
            }).catch(function (error) {
                console.log(error);
                self.RefreshYZM();
                self.logonNow = 0;
            });
        }
    }
}
</script>
<style>@import '../assets/homeContent/login.css';</style>



// WEBPACK FOOTER //
// src/html/login.vue